// Authentication API

import apiClient from './client';
import type {
  ClientRegistrationInput,
  ClientLoginInput,
  ApiResponse,
} from '@phoenixbill/shared';

export interface AuthResponse {
  token: string;
  sessionId: string;
  user: {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    type: 'client' | 'admin' | 'contact';
  };
  message: string;
}

export const authApi = {
  /**
   * Register a new client
   */
  async register(data: ClientRegistrationInput): Promise<AuthResponse> {
    const response = await apiClient.post<ApiResponse<AuthResponse>>(
      '/public/auth/register',
      data
    );
    return response.data.data!;
  },

  /**
   * Login as client
   */
  async login(data: ClientLoginInput): Promise<AuthResponse> {
    const response = await apiClient.post<ApiResponse<AuthResponse>>('/public/auth/login', data);
    return response.data.data!;
  },

  /**
   * Login as admin
   */
  async loginAdmin(data: { username: string; password: string }): Promise<AuthResponse> {
    const response = await apiClient.post<ApiResponse<AuthResponse>>(
      '/public/auth/admin/login',
      data
    );
    return response.data.data!;
  },

  /**
   * Logout
   */
  async logout(): Promise<void> {
    await apiClient.post('/public/auth/logout');
  },

  /**
   * Verify token
   */
  async verify(): Promise<{
    user: {
      id: number;
      type: string;
      email: string;
    };
  }> {
    const response = await apiClient.get<ApiResponse<any>>('/public/auth/verify');
    return response.data.data!;
  },

  /**
   * Get current user
   */
  async me(): Promise<{
    user: {
      id: number;
      type: string;
      email: string;
    };
  }> {
    const response = await apiClient.get<ApiResponse<any>>('/public/auth/me');
    return response.data.data!;
  },
};
